import React from "react";

// eslint-disable-next-line react/prefer-stateless-function
export default class PercentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.inputId = `${Math.round(Math.random() * 10 ** 10)}`;
    this.state = {
      data: JSON.parse(JSON.stringify(this.props)),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ data: this.props });
    }
  }

  onChangeData = e => {
    if (e.target.value >= 0 && e.target.value <= 100) {
      const data = { ...this.state.data };
      data.value = e.target.value;
      this.setState(() => ({ data }));
    }
  };

  render() {
    const { id, value, editable } = this.state.data;
    return (
      <React.Fragment>
        <span className="percent-icon">
          <input
            style={
              editable === true ? { background: "inherit" } : { background: "" }
            }
            id={id || this.inputId}
            type="number"
            value={value}
            disabled={!editable}
            onChange={e => this.onChangeData(e)}
            onBlur={() =>
              this.props.onBlurData(parseFloat(this.state.data.value))
            }
            data-test="percentcomponent-percent-input"
          />
          %
        </span>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/commonComponents/CustomGrid/CustomGridTypeComponents/PercentComponent.js